
import styled from "styled-components";
import { Color, Font, breakpoints } from "@/shared/Constants";



export const ListStyleGeneric = styled.div `
margin-top:18px;
    li {
        position:relative;
        
        &::before{
            content: "";
            position: absolute;
            right: -9px;
            top: -10px;
            width: 1px;
            height: 100%;
            background-color: #E0E0E0;
        }
        &:after {
            content: "";
            position: absolute;
            bottom: 0;
            left: -14px;
            width: 110%;
            height: 1px;
            background-color: #E0E0E0;
        }
        &:nth-child(4n) {
            &:before {
                content: "";
                position: absolute;
                bottom: 0;
                left: -14px;
                width: 110%;
                height: 1px;
                background-color: #fff;
            }
        }
    }
`

